<template>
  <div>

    <!-- NIVELES DE UBICACIÓN -->
    <niveles/>

    <!-- UBICACIONES -->
    <ubicaciones/>

    <!-- UBICACIONES EMPRESA -->
    <ubicaciones-empresa/>

  </div>
</template>

<script>

import niveles from './niveles';
import ubicaciones from './ubicaciones';
import ubicacionesEmpresa from './ubicaciones-empresa';
import {mapActions, mapMutations} from 'vuex';

export default {
  name: 'index',
  async mounted() {
    await this.listarNiveles();
    await this.listarUbicaciones();
    await this.arbolUbicacionesEmpresa();
  },
  components: {
    niveles,
    ubicaciones,
    ubicacionesEmpresa
  }, methods: {
    ...mapActions('ubicacion', [
      'listarNiveles',
      'listarUbicaciones',
      'arbolUbicacionesEmpresa',
    ]),
    ...mapMutations('ubicacion', [
      'resetFiltroUbicaciones',
      'resetFiltroNiveles'
    ])
  },
};
</script>

